// 2026-10-28 · Badge «cuenta impresa» en el dispositivo que actúa: se
// enciende al imprimir y se apaga al comandar AL INSTANTE, sin depender del
// eco del servidor (que llega tras generar el ticket, en segundo plano, y que
// antes se descartaba por ser propio). El eco/la lista del servidor siguen
// siendo la fuente de verdad: ver utils/mesaFreshness.js.
import {
  mesaCheckPrintedLocally,
  mesaCheckPrintedRevert,
  mesaComandadaLocally,
} from "src/redux/actions/checkPrinted";
import { clearPendingPrint, noteMesaWrite, notePendingPrint } from "src/utils/mesaFreshness";

const sameId = (a, b) => a != null && b != null && String(a) === String(b);

export function findMesaBySession(state, sessionId) {
  if (sessionId == null) return null;
  const list = state?.mesas?.mesas || [];
  return (
    list.find((m) => sameId(m?.sessionId, sessionId) || sameId(m?.idSession, sessionId)) || null
  );
}

/**
 * Imprimir la cuenta (pre-pago) de la sesión: marca la mesa. Devuelve
 * `{ mesaId, at }` (para deshacer si la petición falla) o null.
 */
export function markCheckPrintedLocally(sessionId, now = new Date()) {
  return (dispatch, getState) => {
    const mesa = findMesaBySession(getState?.(), sessionId);
    if (!mesa || !mesa.ocupada) return null;
    const at = mesa.checkPrintedAt || now.toISOString();
    notePendingPrint(mesa.id);
    noteMesaWrite(mesa.id);
    dispatch(mesaCheckPrintedLocally({ sessionId, mesaId: mesa.id, at }));
    return { mesaId: mesa.id, at, wasPrinted: !!mesa.checkPrintedAt };
  };
}

export function revertCheckPrintedLocally(mark) {
  return (dispatch) => {
    if (!mark || mark.wasPrinted) return;
    clearPendingPrint(mark.mesaId);
    noteMesaWrite(mark.mesaId);
    dispatch(mesaCheckPrintedRevert({ mesaId: mark.mesaId, at: mark.at }));
  };
}

/** Comandar/guardar otra ronda: la cuenta impresa ya no vale. */
export function clearCheckPrintedOnComanda(mesaId) {
  return (dispatch) => {
    if (mesaId == null) return;
    clearPendingPrint(mesaId);
    noteMesaWrite(mesaId);
    dispatch(mesaComandadaLocally(mesaId));
  };
}
